// Report internal site-search terms to Leadinfo as a single custom pageview.
//
// The search is a Sprig typeahead that re-renders (and pushes ?q= to the URL)
// on every debounced keystroke, so Leadinfo would otherwise log a burst of
// virtual pageviews per search and never expose the actual term. We instead
// fire ONE Leadinfo custom pageview per settled search:
//   /interne-zoekopdracht/<term>/<count>-resultaten
// Term + count are read from data-attributes the server renders on the results
// (count is server-side only — it is not in the URL). The live search itself is
// untouched. Guarded on window.leadinfo (loaded async via GTM, consent-gated),
// so it is a silent no-op when Leadinfo is absent.

const SETTLE_MS = 1200; // wait for the user to stop typing before reporting
const PREFIX = "/interne-zoekopdracht/"; // kept NL on both sites for consistent Leadinfo reporting

let timer = null;
let lastReported = null; // dedup key: term + count

function report(term, count) {
  const key = `${term} ${count}`;
  if (key === lastReported) return; // already reported this exact search
  if (typeof window.leadinfo !== "function") return; // Leadinfo not (yet) loaded

  const url = PREFIX + encodeURIComponent(term) + "/" + count + "-resultaten";
  window.leadinfo("setCustomUrl", url);
  window.leadinfo("trackPageView");
  lastReported = key;
}

document.addEventListener("htmx:afterSwap", (event) => {
  const target = event.detail?.target;
  if (!target) return;

  // Only the search component renders [data-search-term]; key on it directly so
  // we ignore every other Sprig swap (blog/case/product filters) and stay immune
  // to how htmx reports the swap target for an outerHTML replace.
  const data =
    (target.matches?.("[data-search-term]") && target) ||
    target.querySelector?.("[data-search-term]");
  if (!data) return; // < 2 chars / no results block rendered — nothing to report

  const term = (data.dataset.searchTerm || "").trim();
  const count = data.dataset.resultsCount || "0";
  if (!term) return;

  clearTimeout(timer);
  timer = setTimeout(() => report(term, count), SETTLE_MS);
});
